import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react'
import { HeaderSearch as LayoutSearch } from 'src/components'
import { mainStore } from 'enasops/stores'

const Search = () => {
  const navigate = useNavigate()

  const handleMenuSelect = (menuId: string) => {
    const menu = mainStore.flatMenus.find(menu => menu.ID === menuId)
    menu && navigate(`/main/${menu.ID}`)
  }

  return (
    <div className='header__right-search'>
      <LayoutSearch
        fullMode
        dataSource={mainStore.flatMenus.filter(menu => !!menu.IS_LEAF)}
        filterFields={['Nav_MenuForm.CODE', 'Nav_MenuForm.NAME', 'NAME']}
        optionKeyField='ID'
        optionLabelFields={['NAME', 'Nav_MenuForm.CODE']}
        onSelect={handleMenuSelect}
        acProps={{ placeholder: '菜单搜索' }}
        className='menu-search'
      />
    </div>
  )
}

export default observer(Search)